import { IAddressData, inputID } from "./AddressMapHelper";
import { useTranslation } from "hhn-commons";
import { AddressInput, SelectAddressButton } from "./AddressMap.style";
import React from "react";
import { IconButton, InputAdornment } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type AddressMapInputProps = {
  addressData: IAddressData;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onClick: () => void;
  buttonLabel?: string;
  inputId?: string;
  placeholder?: string;
  onClear?: () => void;
  disabled?: boolean;
};

function AddressMapInput({
  addressData,
  onChange,
  onClick,
  buttonLabel,
  inputId,
  placeholder,
  onClear,
  disabled,
}: AddressMapInputProps) {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });
  const elementId = inputId || inputID;
  const showClearButton = onClear && addressData?.placeName;

  return (
    <>
      <AddressInput
        id={elementId}
        data-testid={elementId}
        size="small"
        className="controls"
        type="text"
        value={addressData?.placeName}
        onChange={onChange}
        placeholder={placeholder || tNs("addressField.addressInputPlaceholder")}
        autoFocus
        slotProps={{
          input: {
            endAdornment: showClearButton ? (
              <InputAdornment position="end">
                <IconButton size="small" onClick={onClear}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
          },
        }}
      />
      <SelectAddressButton
        variant="contained"
        id="pac-button"
        data-testid="pac-button"
        onClick={onClick}
        disabled={disabled}
        title={disabled ? tNs("addressField.selectFromSuggestions") : undefined}
      >
        {buttonLabel || tNs("addressField.addressButtonLabel")}
      </SelectAddressButton>
    </>
  );
}

export default AddressMapInput;
